import React, {useState} from "react";
import {Container, Nav, Navbar} from "react-bootstrap";
import "animate.css";
import {useOnScreen} from "../hooks/useOnScreen";

const TopMenu: React.FC = () => {
    const [expanded, setExpanded] = useState(false);
    const casaVisible = useOnScreen("#home", "-10%");

    const handleNavClick = (e: React.MouseEvent, id: string) => {
        setExpanded(false);
        const el = document.getElementById(id);
        if (el) {
            const offset = 0;
            const top = el.getBoundingClientRect().top + window.scrollY + offset;
            window.scrollTo({top, behavior: 'smooth'});
        }
    };

    return (
        <Navbar
            expand="sm"
            expanded={expanded}
            onToggle={setExpanded}
            className="glass-nav fixed-top"
            id="main-nav-links"
        >
            <Container fluid className="mainMenu">
                <Navbar.Toggle aria-controls="basic-navbar-nav"/>
                <Navbar.Collapse id="basic-navbar-nav" className="navBarCollapseCustom">
                    <Nav className="ms-auto me-auto">
                        <Nav.Link className={`custom-margin fs-5 ${
                            casaVisible ? "glass-nav-a" : "glass-nav-b"
                        }`} onClick={(e) => {
                            e.preventDefault();
                            handleNavClick(e, "home")
                        }}>LOBE</Nav.Link>
                        <Nav.Link className={`custom-margin fs-5 ${
                            casaVisible ? "glass-nav-a" : "glass-nav-b"
                        }`} onClick={(e) => {
                            e.preventDefault();
                            handleNavClick(e, "casaLobe")
                        }}>HOTEL</Nav.Link>
                        <Nav.Link className={`custom-margin fs-5 ${
                            casaVisible ? "glass-nav-a" : "glass-nav-b"
                        }`}
                                  onClick={(e) => {
                                      e.preventDefault();
                                      handleNavClick(e, "restaurante")
                                  }}>RESTAURANT</Nav.Link>
                        <Nav.Link className={`custom-margin fs-5 ${
                            casaVisible ? "glass-nav-a" : "glass-nav-b"
                        }`} onClick={(e) => {
                            e.preventDefault();
                            handleNavClick(e, "catering")
                        }}>CATERING</Nav.Link>
                        <Nav.Link className={`custom-margin fs-5 ${
                            casaVisible ? "glass-nav-a" : "glass-nav-b"
                        }`} onClick={(e) => {
                            e.preventDefault();
                            handleNavClick(e, "ubicacion")
                        }}>UBICACIÓN</Nav.Link>
                        <Nav.Link className={`custom-margin fs-5 ${
                            casaVisible ? "glass-nav-a" : "glass-nav-b"
                        }`} onClick={(e) => {
                            e.preventDefault();
                            handleNavClick(e, "contacto")
                        }}>CONTACTO</Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default TopMenu;
